import { BaseModel } from './base';
import { Processo } from './processo';

export class Beneficiario extends BaseModel {
  constructor(
    public id: number,
    public nome: string,
    public numeroDocumento: string,
    public dataEmissaoDocumento: string,
    public orgaoEmissorDocumento: string,
    public ufDocumento: string,
    public sexo: string,
    public dataNascimento: string,
    public cpf: string,
    public rg: string,
    public dddTelefone: string,
    public telefone: string,
    public logradouro: string,
    public numeroLogradouro: string,
    public bairro: string,
    public cidade: string,
    public cep: string,
    public nomeMae: string,
    public acompanhante: boolean,
    public processos: Processo[],
    public recaptcha?: string,
    public email?: string,
    public telefones?: string[],
    public dddTelefone2?: string,
    public telefone2?: string,
    public complemento?: string,
    public municipioIbge?: number,
    // public telefoneDdd2?: string,
    // public telefoneNum2?: string,
    // public telefoneDdd?: string,
    // public telefoneNum?: string
  ) {
    super(id);
  }
}
